import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAccessToken, clearTokens,setTokens } from '../Utils/Storage';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = getAccessToken();
    if (token) {
      // Check if token is expired
      try {
        const tokenData = JSON.parse(atob(token.split('.')[1]));
        const expirationTime = tokenData.exp * 1000; // Convert to milliseconds
        
        if (Date.now() >= expirationTime) {
          clearTokens();
          setIsAuthenticated(false);
        } else {
          setIsAuthenticated(true);
        }
      } catch (error) {
        clearTokens();
        setIsAuthenticated(false);
      }
    }
  }, []);



  const login = (accessToken, refreshToken, tokenExpiration, refreshTokenExpiration) => {
    setTokens(accessToken, refreshToken, tokenExpiration, refreshTokenExpiration);
    setIsAuthenticated(true);
  };

  const logout = () => {
    clearTokens();
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
